import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    data: null,
    error: null,
    loading: false
};
export const slice = createSlice({
    name: 'account',
    initialState: INITIAL_STATE,
    reducers: (create)=>({
            set: create.reducer((state, action)=>{
                return {
                    ...state,
                    loading: false,
                    error: null,
                    data: {
                        ...state.data,
                        ...action.payload
                    }
                };
            })
        })
});
